export default "/images/bc4f3a9705b1bf350485663c8eb5fa36.avif";